import { createFileRoute, Outlet } from '@tanstack/react-router'

import { MastraChat } from '@/widgets/mastra-chat'

export const Route = createFileRoute('/_app/agents/$agentId/chat')({
  component: RouteComponent,
})

export const AgentsChatRoute = Route

function RouteComponent() {
  // MastraChat stays mounted for both `/agents/$agentId/chat` and
  // `/agents/$agentId/chat/$uuid` since this is their shared parent route; the active agent
  // and thread are read from the URL params inside the widget. The Outlet hosts the
  // (param-only) child route.
  return (
    <>
      <MastraChat />
      <Outlet />
    </>
  )
}
